<template>

  <v-container fluid class="pa-1">
    <v-layout row>
      <v-flex xs12>

      <v-card raised>
        <v-card-media src="/static/img/paisaje.jpg" height="300px">

          <v-layout column class="media">
            <v-spacer></v-spacer>
            <v-card-title class="white--text pl-5 pt-5">
              <div class="display-1 pl-5 pt-5">Jose Ángel Hermosilla Rodrigo</div>
            </v-card-title>
          </v-layout>

        </v-card-media>

        <v-layout row>
          <v-flex xs12 class="text-xs-center">
            <v-btn icon href="https://github.com/joseahr" target="_blank">
              <i class="fa fa-github fa-2x"></i>
            </v-btn>
            <v-btn icon href="https://stackoverflow.com/users/3866134/jose-hermosilla-rodrigo?tab=profile" target="_blank">
              <i class="fa fa-stack-overflow fa-2x"></i>
            </v-btn>
            <v-btn icon href="https://www.facebook.com/jose.hermosillarodrigo" target="_blank">
              <i class="fa fa-facebook fa-2x"></i>
            </v-btn>
            <v-btn icon href="https://www.instagram.com/josehermosillarodrigo/" target="_blank">
              <i class="fa fa-instagram fa-2x"></i>
            </v-btn>
            <v-btn icon href="https://www.linkedin.com/in/jose-%C3%A1ngel-hermosilla-rodrigo-70a590147/" target="_blank">
              <i class="fa fa-linkedin fa-2x"></i>
            </v-btn>
          </v-flex>
        </v-layout>

        <v-divider></v-divider>

        <v-list two-line>

          <v-list-tile @click="">
            <v-list-tile-action>
              <v-icon color="indigo">mail</v-icon>
            </v-list-tile-action>
            <v-list-tile-content>
              <v-list-tile-title>joherro123@gmail.com</v-list-tile-title>
              <v-list-tile-sub-title>Personal</v-list-tile-sub-title>
            </v-list-tile-content>
          </v-list-tile>

          <v-list-tile @click="">
            <v-list-tile-action></v-list-tile-action>
            <v-list-tile-content>
              <v-list-tile-title>joherro3@topo.upv.es</v-list-tile-title>
              <v-list-tile-sub-title>Universidad</v-list-tile-sub-title>
            </v-list-tile-content>
          </v-list-tile>
        
          <v-divider inset></v-divider>

          <v-list-tile @click="">
            <v-list-tile-action>
              <v-icon color="indigo">location_on</v-icon>
            </v-list-tile-action>
            <v-list-tile-content>
              <v-list-tile-title>España</v-list-tile-title>
              <v-list-tile-sub-title>Torrent, Valencia 46900</v-list-tile-sub-title>
            </v-list-tile-content>
          </v-list-tile>

          <v-divider inset></v-divider>

          <v-list-tile v-for="estudio in estudios" :key="estudio.title" @click="" three-lines>
            <v-list-tile-action>
              <v-icon v-if="estudio.icon" color="indigo">{{estudio.icon}}</v-icon>
            </v-list-tile-action>
            <v-list-tile-content>
              <v-list-tile-title v-html="estudio.title"></v-list-tile-title>
              <v-list-tile-sub-title v-html="estudio.centro"></v-list-tile-sub-title>
              <v-list-tile-sub-title v-html="estudio.periodo"></v-list-tile-sub-title>
            </v-list-tile-content>
          </v-list-tile>

          <v-divider></v-divider>

        </v-list>

        <v-card-text>

          <b>Conocimientos</b>

          <div class="text-xs-center">
            <v-chip color="primary" 
              text-color="white" 
              v-for="conocimiento in conocimientos" 
              :key="conocimiento">{{conocimiento}}</v-chip>
          </div>

          <b>Tecnologías Usadas</b>

          <div class="text-xs-center">
            <v-chip color="primary" 
              text-color="white" 
              v-for="tecnologia in tecnologias" 
              :key="tecnologia">{{tecnologia}}</v-chip>
          </div>

          <b>StackOverflow</b>

          <div class="text-xs-center">
            <a href="https://stackexchange.com/users/4785502">
            <img src="https://stackexchange.com/users/flair/4785502.png" width="208" height="58" alt="profile for Jose Hermosilla Rodrigo on Stack Exchange, a network of free, community-driven Q&amp;A sites" title="profile for Jose Hermosilla Rodrigo on Stack Exchange, a network of free, community-driven Q&amp;A sites">
            </a>
          </div>

        </v-card-text>

        </v-card>

      </v-flex>
    </v-layout>
  </v-container>

</template>

<style>
.shadowed {
  box-shadow: 0 1px 5px rgba(0, 0, 0, 0.2), 0 2px 2px rgba(0, 0, 0, 0.14),
    0 3px 1px -2px rgba(0, 0, 0, 0.12);
}

.shadowed:hover {
  transform: scale(1.1);
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.2), 0 4px 4px rgba(0, 0, 0, 0.14),
    0 6px 2px -4px rgba(0, 0, 0, 0.12);
}

.media {
  height: 100%;
  margin: 0;
}
</style>

<script>
/* eslint-disable */
import tecnologias from "../files/tecnologias.json";
import conocimientos from "../files/conocimientos.json";
import estudios from "../files/estudios.json";

export default {
  data() {
    return {
      tecnologias,
      conocimientos,
      estudios
    };
  }
};
</script>



// WEBPACK FOOTER //
// Profile.vue?f62fe6fa